import { FC, ReactNode } from 'react';
import XhtmlTextBlock from './XhtmlTextBlock';
import NyhetsBlock from './NyhetsBlock';
import RubrikBlock from './RubrikBlock';
import HeroknappBlock from './HeroknappBlock';
import Sidfotblock from './Sidfotblock';
import AccordionBlock from './AccordionBlock/AccordionBlock';
import AccordionGroupBlock from './AccordionBlock/AccordionGroupBlock';
import KursBlock from './KursBlock/KursBlock';
import KalenderBlock from './KalenderhändelseBlock';
import FlikgruppBlock from './FlikgruppBlock';
import { ContentResponse } from '../types/shared';
import { ContentTypeGuid } from '../types/enums';
import { AccordionBlockResponse, XhtmlTextBlockResponse } from '../types/blocks';
import NamnBlock from './NamnBlock/NamnBlock';
import TabellBlock from './TabellBlock';
import YoutubeBlock from './YoutubeBlock/YoutubeBlock';

interface IContentBlockProps {
  contentResponse: ContentResponse;
}

const ContentBlock: FC<IContentBlockProps> = ({ contentResponse }): ReactNode => {
  const renderContentBlock = () => {
    switch (contentResponse.contentTypeGuid) {
      case ContentTypeGuid.XhtmlTextBlock:
        return <XhtmlTextBlock xhtmlTextBlockResponse={contentResponse.content as XhtmlTextBlockResponse} />;
      case ContentTypeGuid.RubrikBlock:
        return <RubrikBlock contentResponse={contentResponse} />;
      case ContentTypeGuid.HeroknappBlock:
        return <HeroknappBlock contentResponse={contentResponse} />;
      case ContentTypeGuid.NyhetsBlock:
        return <NyhetsBlock contentResponse={contentResponse} />;
      case ContentTypeGuid.Sidfotblock:
        return <Sidfotblock contentResponse={contentResponse} />;
      case ContentTypeGuid.AccordionBlock:
        return <AccordionBlock content={contentResponse.content as AccordionBlockResponse} />;
      case ContentTypeGuid.AccordionGroupBlock:
        return <AccordionGroupBlock content={contentResponse} />;
      case ContentTypeGuid.KursBlock:
        return <KursBlock contentResponse={contentResponse} />;
      case ContentTypeGuid.KalenderhändelseBlock:
        return <KalenderBlock contentResponse={contentResponse} />;
      case ContentTypeGuid.FlikgruppBlock:
        return <FlikgruppBlock contentResponse={contentResponse} />;
      case ContentTypeGuid.NamnBlock:
        return <NamnBlock contentResponse={contentResponse} />;
      case ContentTypeGuid.TabellBlock:
        return <TabellBlock contentResponse={contentResponse} />;
      case ContentTypeGuid.YoutubeBlock:
        return <YoutubeBlock contentResponse={contentResponse} />;
      default:
        console.warn(`Renderingsimplementation saknas för Block med contentTypeGuid: ${contentResponse.contentTypeGuid}`);
        return <></>;
    }
  };

  return (renderContentBlock());
};

export default ContentBlock;
